import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductDetailsMainSlider, ProductDetailsThumbSlider, ProductSlider } from '../../../../shared/data/slider';
import { EcomProd, Product, options, ordermodule } from '../../../../shared/classes/product';
import { ProductService } from '../../../../shared/services/product.service';
import { SizeModalComponent } from "../../../../shared/components/modal/size-modal/size-modal.component";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MyService } from 'src/app/shared/services/myservice';
import { Title } from '@angular/platform-browser';
import { ExternalService } from 'src/app/shared/services/external.service';


@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.scss']
})
export class ProductLeftSidebarComponent implements OnInit {
  @ViewChild('loginModel', { static: true }) loginModel: ElementRef<any>

  @ViewChild('RecomendProd', { static: true }) RecomendProd: ElementRef<any>

  @ViewChild('ReviewImg', { static: true }) ReviewImg: ElementRef<any>
  @ViewChild('Reviews', { static: true }) Reviews: ElementRef<any>
  @ViewChild('Share', { static: true }) Share: ElementRef<any>



  public product: Product = {};
  public ecomproduct: EcomProd = {};
  public counter: number = 1;
  public activeSlide: any = 0;
  public selectedSize: any;
  public mobileSidebar: boolean = false;
  public active = 1;
  public ecomprodpredefined: any = []
  public topFirstProduct
  public topFirstPVariant: any
  public selkq: number = 0;
  public selkgprice: number = 0
  public varPrice: number = 0
  public varqty: number = 0
  public varselprice: number = 0
  public ecomprodoptions: any[] = [];
  public ecomprodvariants: any[] = [];

  message: string = ''
  public prod: any = []
  public ordermodule: ordermodule
    = {
      product: {},
      weight: {},
      options: [],
    }

  public opt: options
    = {
      addons: [],
      variants: {},
    }

  // public ordermodule: ordermodule[] = [];

  addprice: number = 0
  prdname: string
  Ecart: any = []
  preDEfQTy: number = 0
  VarId: number = 0
  ADDNS: any = []
  Recprod: any = []
  @ViewChild("sizeChart") SizeChart: SizeModalComponent;

  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;
  public productsideForm: UntypedFormGroup;
  prdid: any
  starcounts = 0

  data5 = 0
  data4 = 0
  data3 = 0
  data2 = 0
  data1 = 0

  finalratingstar = 0

  FilterReviewData: any = []
  ecomprodoptionsall: any = []
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public productService: ProductService,
    private fb: UntypedFormBuilder,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private myService: MyService,
    private titleService: Title,
    private externalService: ExternalService
  ) {


    localStorage.setItem('mypg', '2');

    this.myService._pageId.next(2);




    // this.ReviewData = JSON.parse(localStorage.getItem("LocalReview"))
    // console.log(this.ReviewData)

    // console.log(STRvalue)



    // this.productsideForm = this.fb.group({
    //   // message: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]*$/), Validators.maxLength(50)]]
    //   message: ['', [Validators.required, Validators.maxLength(50)]]
    // })
    // console.log(this.route.data)
    this.route.data.subscribe(response => this.product = response.data);

    this.route.data.subscribe(response => {
      this.preDEfQTy = 0
      this.ecomproduct = response.data;
      // console.log(this.ecomproduct)
      this.fdata = JSON.parse(localStorage.getItem("fav"));

      this.ecomproduct.image = [{ src: this.ecomproduct.img, alt: this.ecomproduct.img }];
      this.ecomproduct.totalrating = this.ecomproduct.datacount.total || 0;
      this.ecomproduct.starscount = this.ecomproduct.datacount.starscount || 0;

      this.prod = this.ecomproduct['products'];
      // console.log(this.prod)
      this.Recprod = this.ecomproduct['rp'] || [];
      const idpid = this.prod[0]?.id;

      this.ecomprodpredefined = this.ecomproduct['predefinedqty'];
      this.ecomprodvariants = this.ecomproduct['varients'];
      this.filteredVariants = this.ecomproduct['varients'];

      if (this.fdata) {
        this.fdata.forEach(x => {
          if (x.pid === idpid) {
            this.favbool = true;
          }
        });
      }

      this.Recprod.forEach(element => {
        element.Qty = 0;
        // element.PreQty = 0;
        element.pname = element.name;
      });

      this.prdid = this.prod[0]?.id;
      this.prdname = this.prod[0]?.name;

      localStorage.setItem('productId', this.prdid);
      localStorage.setItem('prdname', this.prdname);

      this.Ecart = this.ecomproduct['ecart'] || [];
      // console.log(this.Ecart)
      if (this.Ecart.Productid > 0) {
        this.message = this.Ecart.Message;
        this.counter = this.Ecart.Quantity;
        this.preDEfQTy = this.Ecart.PredefinedqtyId;
        this.VarId = this.Ecart.VariantId;
        this.ADDNS = this.Ecart.Addons || [];
        this.selectedOptions = this.ADDNS;

        if (this.selectedOptions.length > 0) {
          this.selectedOptions = [...new Set(this.selectedOptions.map(x => x.id))]
            .map(id => this.selectedOptions.find(x => x.id === id));
          this.clickedStates[0] = !this.clickedStates[0];
        }
      }
      // console.log('111111111', this.ecomprodpredefined.length,this.ecomprodpredefined,this.preDEfQTy)

      if (this.ecomprodpredefined.length > 0) {
        this.topFirstProduct = this.preDEfQTy === 0
          ? this.ecomprodpredefined.find(x => x.qty === 0.5)
          : this.ecomprodpredefined.find(x => x.id === this.preDEfQTy);
      } else {
        this.topFirstProduct = [];
      }
      // console.log(this.topFirstProduct)
      this._displayedPrice = this.topFirstProduct?.price || 0;
      this.selkgprice = this.topFirstProduct?.price || 0;
      this.displayedPrice = this.selkgprice;

      if (this.selectedOptions.length > 0) {
        this.Topt = this.selectedOptions.reduce((sum, ele) => sum + ele.price, 0);
      }

      // Filter variants where topFirstProduct.id matches paProdId and show only "Heart Shape" and "Round Shape"
      this.ecomprodvariants = this.ecomprodvariants
        .filter(v => v.paProdId === this.topFirstProduct?.id &&
          (v.qtyText.includes("Heart Shape") || v.qtyText.includes("Round Shape")))
        .sort((a, b) => (a.qtyText.includes("Round Shape") ? -1 : 1)); // Ensure "Round Shape" appears first


      if (this.VarId === 0) {
        // Ensure the Round Shape is always selected first
        this.topFirstPVariant =
          this.ecomprodvariants.find(v => v.qtyText.includes("Round Shape")) ||
          this.ecomprodvariants.find(v => v.qtyText.includes("Heart Shape")) ||
          this.ecomprodvariants[0];

      } else {
        this.topFirstPVariant = this.ecomprodvariants.find(x => x.id === this.VarId);
      }

      this.varqty = this.topFirstPVariant?.qty || 0;
      this.varPrice = this.topFirstPVariant?.price || 0;

      this.ecomprodoptionsall = this.ecomproduct['options'];
      this.ecomprodoptions = this.ecomproduct['options'];

      const data = this.ecomprodoptions.find(x => x.paProdId === this.topFirstProduct?.id);
      this.ecomprodoptions = data ? [data] : [];

      this.ecomprodoptions.forEach(() => this.clickedStates.push(false));

      this.ecomprodoptions.forEach(element => {
        this.addprice = element.price;
      });

      // Ensure displayedPrice calculation includes selected options
      const selectedOptionsPrice = this.selectedOptions.reduce((total, opt) => total + (opt.price || 0), 0);
      this.displayedPrice = (this.selkgprice + selectedOptionsPrice + this.varPrice) * (this.Ecart.Quantity || this.Cquantity);

      if (this.topFirstProduct?.totalQty > 2) {
        this.ecomprodvariants = this.ecomprodvariants.filter(x => x.qtyText.includes("Box Shape"));
      } else {
        this.ecomprodvariants = this.ecomprodvariants.filter(x => !x.qtyText.includes("Box Shape"));
      }

      // console.log(this.ecomprodpredefined)

      // console.log(this.topFirstProduct)
    });


    // console.log(this.prod)
    if (this.prod.length > 0) {



      this.externalService.GetReviews(this.prod[0].id, 0, 0).subscribe(response => {
        // console.log(response)
        // this.starcounts = 0

        if (response != null) {
          this.ReviewData = response
          // this.ReviewData.notes = JSON.parse(this.ReviewData.notes)

          this.ReviewData.forEach(element => {
            this.starcounts += element.star
            const reviewcount = ((this.starcounts * this.ReviewData.length) / 100)
            this.reviewcount = reviewcount.toFixed(0)
            // element.notes = JSON.parse(element.notes)
            element.img = JSON.parse(element.img)
            element.notes = JSON.parse(element.notes)
          });
          // console.log(this.ReviewData)
          const star5 = this.ReviewData.filter(x => x.star == 5)
          // console.log(star5)
          star5.forEach(element => {
            this.data5 += element.star
          });

          const star4 = this.ReviewData.filter(x => x.star == 4)
          // console.log(star4)
          star4.forEach(element => {
            this.data4 += element.star
          });
          const star3 = this.ReviewData.filter(x => x.star == 3)
          // console.log(star3)
          star3.forEach(element => {
            this.data3 += element.star
          });
          const star2 = this.ReviewData.filter(x => x.star == 2)
          // console.log(star2)
          star2.forEach(element => {
            this.data2 += element.star
          });
          const star1 = this.ReviewData.filter(x => x.star == 1)
          // console.log(star1)
          star1.forEach(element => {
            this.data1 += element.star
          });
          // console.log(this.data5, this.data4, this.data3, this.data2, this.data1)

          // const STRvalueMultiple = ((this.data5 * star5.length) + (this.data4 * star4.length) + (this.data3 * star3.length) + (this.data2 * star2.length) + (this.data1 * star1.length))

          const STRvalueMultiple = ((star5.length * 5) + (star4.length * 4) + (star3.length * 3) + (star2.length * 2) + (star1.length * 1))

          // console.log(STRvalueMultiple)

          const finalval = (STRvalueMultiple / this.ReviewData.length)

          // console.log(finalval)

          this.ReviewData = this.ReviewData

          this.FilterReviewData = this.ReviewData.slice(0, 5);

          // console.log(this.FilterReviewData)

          // const STRvalue = (this.data5 + this.data4 + this.data3 + this.data2 + this.data1)

          let num: number = finalval;
          let roundedNum: number = parseFloat(num.toFixed(1));

          this.finalratingstar = roundedNum
          // console.log(this.finalratingstar); 

        }
      })
    }
    // this.productService.EcomProducts.subscribe(response => {
    //   this.ecomproduct = response
    // console.log('ProductDetails', this.ecomproduct)

    //   console.log(this.ecomproduct['products'][0].description.replace(/\s+/g, '-'));       
    // }) 
    this.titleService.setTitle(this.ecomproduct.products[0]?.name);
  }

  displayedPrice: number = 0;
  _displayedPrice: number = 0;
  selectedShape: string = 'ROUND SHAPE'; // Default selection
  selectShape(shape: string) {
    this.selectedShape = shape;
  }



  updateDisplayedPriceg(id: any) {

    const selectedPredefinedQty = this.ecomprodpredefined.find(item => item.id === id);

    if (selectedPredefinedQty) {
      this.topFirstProduct.id = selectedPredefinedQty.id;
      this.displayedPrice = selectedPredefinedQty.price;

      // Check if availableShapes exists and contains values
      if (selectedPredefinedQty.availableShapes && selectedPredefinedQty.availableShapes.length > 0) {

        // Maintain the selected shape if available, otherwise pick the first one
        if (!selectedPredefinedQty.availableShapes.includes(this.selectedShape)) {
          this.selectedShape = selectedPredefinedQty.availableShapes[0];
        }
      } else {
        // console.warn('No available shapes for the selected weight');
      }
    }
  }






  productid = 0
  totalRating = 0
  reviewcount: any

  ReviewData: any = []

  ngOnInit(): void {
    this.ecomprodpredefined = []

    // console.log("dddd", this.product)
    // this.externalService.GetReviews(this.prod[0].id)
    // this.externalService.getreview.subscribe(response => {
    // console.log(response)
    // this.ReviewData = response
    this.route.data.subscribe(response => this.product = response.data);

    this.route.data.subscribe(response => {
      this.ecomproduct = response.data;
      // console.log(this.ecomproduct)
      this.fdata = JSON.parse(localStorage.getItem("fav"));

      this.ecomproduct.image = [{ src: this.ecomproduct.img, alt: this.ecomproduct.img }];
      this.ecomproduct.totalrating = this.ecomproduct.datacount.total || 0;
      this.ecomproduct.starscount = this.ecomproduct.datacount.starscount || 0;

      this.prod = this.ecomproduct['products'];
      // console.log(this.prod)
      this.Recprod = this.ecomproduct['rp'] || [];
      const idpid = this.prod[0]?.id;

      this.ecomprodpredefined = this.ecomproduct['predefinedqty'];
      this.ecomprodvariants = this.ecomproduct['varients'];
      this.filteredVariants = this.ecomproduct['varients'];

      if (this.fdata) {
        this.fdata.forEach(x => {
          if (x.pid === idpid) {
            this.favbool = true;
          }
        });
      }

      this.Recprod.forEach(element => {
        element.Qty = 0;
        element.pname = element.name;
      });

      this.prdid = this.prod[0]?.id;
      this.prdname = this.prod[0]?.name;

      localStorage.setItem('productId', this.prdid);
      localStorage.setItem('prdname', this.prdname);

      this.Ecart = this.ecomproduct['ecart'] || [];

      if (this.Ecart.Productid > 0) {
        this.message = this.Ecart.Message;
        this.counter = this.Ecart.Quantity;
        this.preDEfQTy = this.Ecart.PredefinedqtyId;
        this.VarId = this.Ecart.VariantId;
        this.ADDNS = this.Ecart.Addons || [];
        this.selectedOptions = this.ADDNS;

        if (this.selectedOptions.length > 0) {
          this.selectedOptions = [...new Set(this.selectedOptions.map(x => x.id))]
            .map(id => this.selectedOptions.find(x => x.id === id));
          this.clickedStates[0] = !this.clickedStates[0];
        }
      }

      if (this.ecomprodpredefined.length > 0) {
        this.topFirstProduct = this.preDEfQTy === 0
          ? this.ecomprodpredefined.find(x => x.qty === 0.5)
          : this.ecomprodpredefined.find(x => x.id === this.preDEfQTy);
      } else {
        this.topFirstProduct = [];
      }

      this._displayedPrice = this.topFirstProduct?.price || 0;
      this.selkgprice = this.topFirstProduct?.price || 0;
      this.displayedPrice = this.selkgprice;

      if (this.selectedOptions.length > 0) {
        this.Topt = this.selectedOptions.reduce((sum, ele) => sum + ele.price, 0);
      }

      // Filter variants where topFirstProduct.id matches paProdId and show only "Heart Shape" and "Round Shape"
      this.ecomprodvariants = this.ecomprodvariants
        .filter(v => v.paProdId === this.topFirstProduct?.id &&
          (v.qtyText.includes("Heart Shape") || v.qtyText.includes("Round Shape")))
        .sort((a, b) => (a.qtyText.includes("Round Shape") ? -1 : 1)); // Ensure "Round Shape" appears first


      if (this.VarId === 0) {
        // Ensure the Round Shape is always selected first
        this.topFirstPVariant =
          this.ecomprodvariants.find(v => v.qtyText.includes("Round Shape")) ||
          this.ecomprodvariants.find(v => v.qtyText.includes("Heart Shape")) ||
          this.ecomprodvariants[0];

      } else {
        this.topFirstPVariant = this.ecomprodvariants.find(x => x.id === this.VarId);
      }

      this.varqty = this.topFirstPVariant?.qty || 0;
      this.varPrice = this.topFirstPVariant?.price || 0;

      this.ecomprodoptionsall = this.ecomproduct['options'];
      this.ecomprodoptions = this.ecomproduct['options'];

      const data = this.ecomprodoptions.find(x => x.paProdId === this.topFirstProduct?.id);
      this.ecomprodoptions = data ? [data] : [];

      this.ecomprodoptions.forEach(() => this.clickedStates.push(false));

      this.ecomprodoptions.forEach(element => {
        this.addprice = element.price;
      });

      // Ensure displayedPrice calculation includes selected options
      const selectedOptionsPrice = this.selectedOptions.reduce((total, opt) => total + (opt.price || 0), 0);
      this.displayedPrice = (this.selkgprice + selectedOptionsPrice + this.varPrice) * (this.Ecart.Quantity || this.Cquantity);

      if (this.topFirstProduct?.totalQty > 2) {
        this.ecomprodvariants = this.ecomprodvariants.filter(x => x.qtyText.includes("Box Shape"));
      } else {
        this.ecomprodvariants = this.ecomprodvariants.filter(x => !x.qtyText.includes("Box Shape"));
      }

      // console.log(this.ecomprodvariants)
    });


    // console.log(this.prod)
    if (this.prod.length > 0) {



      this.externalService.GetReviews(this.prod[0].id, 0, 0).subscribe(response => {
        // console.log(response)
        // this.starcounts = 0

        if (response != null) {
          this.ReviewData = response
          // this.ReviewData.notes = JSON.parse(this.ReviewData.notes)

          this.ReviewData.forEach(element => {
            this.starcounts += element.star
            const reviewcount = ((this.starcounts * this.ReviewData.length) / 100)
            this.reviewcount = reviewcount.toFixed(0)
            // element.notes = JSON.parse(element.notes)
            element.img = JSON.parse(element.img)
            element.notes = JSON.parse(element.notes)
          });
          // console.log(this.ReviewData)
          const star5 = this.ReviewData.filter(x => x.star == 5)
          // console.log(star5)
          star5.forEach(element => {
            this.data5 += element.star
          });

          const star4 = this.ReviewData.filter(x => x.star == 4)
          // console.log(star4)
          star4.forEach(element => {
            this.data4 += element.star
          });
          const star3 = this.ReviewData.filter(x => x.star == 3)
          // console.log(star3)
          star3.forEach(element => {
            this.data3 += element.star
          });
          const star2 = this.ReviewData.filter(x => x.star == 2)
          // console.log(star2)
          star2.forEach(element => {
            this.data2 += element.star
          });
          const star1 = this.ReviewData.filter(x => x.star == 1)
          // console.log(star1)
          star1.forEach(element => {
            this.data1 += element.star
          });
          // console.log(this.data5, this.data4, this.data3, this.data2, this.data1)

          // const STRvalueMultiple = ((this.data5 * star5.length) + (this.data4 * star4.length) + (this.data3 * star3.length) + (this.data2 * star2.length) + (this.data1 * star1.length))

          const STRvalueMultiple = ((star5.length * 5) + (star4.length * 4) + (star3.length * 3) + (star2.length * 2) + (star1.length * 1))

          // console.log(STRvalueMultiple)

          const finalval = (STRvalueMultiple / this.ReviewData.length)

          // console.log(finalval)

          this.ReviewData = this.ReviewData

          this.FilterReviewData = this.ReviewData.slice(0, 5);

          // console.log(this.FilterReviewData)

          // const STRvalue = (this.data5 + this.data4 + this.data3 + this.data2 + this.data1)

          let num: number = finalval;
          let roundedNum: number = parseFloat(num.toFixed(1));

          this.finalratingstar = roundedNum
          // console.log(this.finalratingstar); 

        }
      })
    }
    // this.productService.EcomProducts.subscribe(response => {
    //   this.ecomproduct = response
    // console.log('ProductDetails', this.ecomproduct)

    //   console.log(this.ecomproduct['products'][0].description.replace(/\s+/g, '-'));       
    // }) 
    this.titleService.setTitle(this.ecomproduct.products[0]?.name);


    this.myService.searchresult.subscribe(data => {
      // console.log(data)
      this.buttonText = data;
      // console.log(this.buttonText)

    })
    this.starcounts = 0
    // console.log(this.ReviewData)
    if (this.ReviewData.length > 0) {

      this.ReviewData.forEach(element => {
        this.starcounts += element.star
        const reviewcount = ((this.starcounts * this.ReviewData.length) / 100)
        this.reviewcount = reviewcount.toFixed(0)
        element.notes = JSON.parse(element.notes)
        element.img = JSON.parse(element.img)
      });

      // this.ReviewData.notes = JSON.parse(this.ReviewData.notes)

      const star5 = this.ReviewData.filter(x => x.star == 5)
      // console.log(star5)
      star5.forEach(element => {
        this.data5 += element.star
      });

      const star4 = this.ReviewData.filter(x => x.star == 4)
      // console.log(star4)
      star4.forEach(element => {
        this.data4 += element.star
      });
      const star3 = this.ReviewData.filter(x => x.star == 3)
      // console.log(star3)
      star3.forEach(element => {
        this.data3 += element.star
      });
      const star2 = this.ReviewData.filter(x => x.star == 2)
      // console.log(star2)
      star2.forEach(element => {
        this.data2 += element.star
      });
      const star1 = this.ReviewData.filter(x => x.star == 1)
      // console.log(star1)
      star1.forEach(element => {
        this.data1 += element.star
      });
      // console.log(this.data5, this.data4, this.data3, this.data2, this.data1)

      // const STRvalueMultiple = ((this.data5 * star5.length) + (this.data4 * star4.length) + (this.data3 * star3.length) + (this.data2 * star2.length) + (this.data1 * star1.length))

      const STRvalueMultiple = ((star5.length * 5) + (star4.length * 4) + (star3.length * 3) + (star2.length * 2) + (star1.length * 1))

      // console.log(STRvalueMultiple)

      const finalval = (STRvalueMultiple / this.ReviewData.length)

      // console.log(finalval)
      this.FilterReviewData = this.ReviewData.slice(0, 5);

      // console.log(this.FilterReviewData)

      // const STRvalue = (this.data5 + this.data4 + this.data3 + this.data2 + this.data1)

      let num: number = finalval;
      let roundedNum: number = parseFloat(num.toFixed(1));

      this.finalratingstar = roundedNum
      // console.log(this.finalratingstar); 

    }
    // })


    this.productid = this.route.snapshot.params['id']
    // console.log('productid', this.productid)
    this.Cquantity = 1;
    // this.GetProductDetails()

    this.review.forEach(element => {
      this.totalRating += element.rating
    });
    // console.log(this.totalRating)


    // console.log(this.reviewcount)
  }



  // Get Product Color
  Color(variants) {
    const uniqColor = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqColor.indexOf(variants[i].color) === -1 && variants[i].color) {
        uniqColor.push(variants[i].color)
      }
    }
    return uniqColor
  }

  // Get Product Size
  Size(variants) {
    const uniqSize = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqSize.indexOf(variants[i].size) === -1 && variants[i].size) {
        uniqSize.push(variants[i].size)
      }
    }
    return uniqSize
  }

  selectSize(size) {
    this.selectedSize = size;
  }


  // _________________________ QUANTITY CHANGES

  // Increament
  increment() {


    if (this.counter < 10) {
      this.counter++;

      this.displayedPrice = (this.selkgprice + this.options + this.varPrice) * this.counter
      // console.log(this.displayedPrice);
      // console.log(this.displayedPrice, this.options, this.counter);
    }

    // this.displayedPrice = this.counter * this.topFirstProduct.price
    // console.log('quantity+price', this.quantity);

    //  this.displayedPrice*=this.counter;


    //  const dsp = this.topFirstProduct.price * this.counter
    //  console.log(dsp);


    //this.displayedPrice = dsp

    this.Cquantity++

    // this.displayedPrice * this.Cquantity


    this.updateTotalPrice()

  }




  Cquantity: number = 1

  // Decrement

  decrement() {

    if (this.counter > 1) this.counter--;
    // console.log(this.counter);
    // this.displayedPrice*=this.counter;

    // const dsp = this.topFirstProduct.price * this.counter
    // console.log(dsp);

    // this.displayedPrice = dsp

    // this.displayedPrice = this.counter * this.topFirstProduct.price
    // console.log('quantity+price', this.quantity);

    this.Cquantity--

    this.displayedPrice = (this.selkgprice + this.options + this.varPrice) * this.counter
    // console.log(this.displayedPrice);
    // console.log(this.displayedPrice, this.options, this.counter);
    this.updateTotalPrice()
  }

  // Add to cart
  // async addToCart(product: any) {
  //   console.log('AddTOCart', product);
  //   this.ordermodule.forEach(element => {
  //     element.product.forEach(ele => {
  //       ele.grandtotal = 0
  //       ele.quantity = this.counter || 1;
  //     })
  //     element.weight = this.topFirstProduct
  //     element.options = product.options

  //   });    
  //   console.log(this.ordermodule);



  //   const status = await this.productService.addToCart(product);

  //   // const status = await this.productService.addToCart(product);
  //   console.log(status);

  //   if (status)
  //     this.router.navigate(['/shop/cart']);

  // }

  cart: any
  cartItem: any
  buttonText: string = 'Add to Cart';
  cartItemCount: number = 0;

  get f() { return this.productsideForm.controls; }
  submitted: boolean = false

  AddonsData: any = []
  CartId: number = 0
  async addToCart(product: EcomProd) {
    if (localStorage.getItem('denglu') === '1') {
      // console.log('Adding to Cart:', product);
      // this.submitted = true
      // if (this.productsideForm.invalid) {
      //   return;
      // }
      // this.message = this.productsideForm.controls.message.value;
      // console.log(this.message);

      // Update weight and options in the ordermodule
      this.ordermodule.weight = this.topFirstProduct;
      this.AddonsData = this.selectedOptions;
      this.opt.addons = this.AddonsData
      // console.log(this.opt)
      // console.log( this.topFirstProduct)
      // console.log(this.topFirstPVariant)
      if (this.topFirstPVariant == null) {
        this.topFirstPVariant = {}
      }
      this.topFirstPVariant.weight = this.topFirstProduct.totalQty

      // this.topFirstPVariant.push({ weight: this.topFirstProduct });

      // console.log( this.topFirstPVariant)
      this.opt.variants = this.topFirstPVariant;
      this.opt.msg = this.message

      const cusid = localStorage.getItem('customerid');
      const integerValue = parseInt(cusid);
      this.ordermodule.customerid = integerValue
      this.ordermodule.cid = 12



      this.CartId = product["cartid"]
      // console.log(this.CartId)
      this.ordermodule.options.push(this.opt)
      // Create a cart item object
      const cartItem = {
        id: product.products[0].id,
        name: product.products[0].name,
        imgUrl: product.products[0].imgUrl,
        quantity: this.counter,
        message: this.message,
        price: this._displayedPrice,
        grandTotal: this.displayedPrice,
        optionsprice: this.options,
        categoryId: product.products[0]?.categoryId
        // catId: 
      };
      this.ordermodule.quantity = this.counter,
        // console.log(cartItem)

        this.cartItem = cartItem
      this.ordermodule.product = this.cartItem


      // this.ordermodule.product = product.products;

      // console.log(this.ordermodule);

      // const status = await this.productService.addToCart(this.ordermodule);
      document.getElementById('preloaderpl').style.display = 'block'
      this.productService.SaveCArt(this.ordermodule).subscribe(response => {
        // console.log(response)
        // console.log(response.status,this.CartId)
        if (response.status == 200 && this.CartId == 0) {
          document.getElementById('preloaderpl').style.display = 'none'
          this.toastrService.success('Cart', ' Cart Added Successfully')

          // setTimeout(() => {

          if (this.cartItem.categoryId != 70) {
            this.modalService.open(this.RecomendProd, { centered: true, size: 'lg' });

          }
          this.updateButtonText();


          // }, 300);
        } else {
          // this.toastrService.error('Cart', 'Cart Added UnSuccessfully !..')
          document.getElementById('preloaderpl').style.display = 'none'
          this.updateButtonText();
        }

        const count = response.cartcount
        localStorage.setItem("myApp_CartCount", JSON.stringify(count));

        this.myService.cartsource.next(count)
      });
      //  if (status)
      //     this.router.navigate(['/shop/cart']);

      this.cartItemCount++;



    } else {
      this.ordermodule.weight = this.topFirstProduct;
      this.AddonsData = this.selectedOptions;
      this.opt.addons = this.AddonsData
      // console.log(this.opt)
      // console.log( this.topFirstProduct)
      // console.log(this.topFirstPVariant)
      if (this.topFirstPVariant == null) {
        this.topFirstPVariant = {}
      }
      this.topFirstPVariant.weight = this.topFirstProduct.totalQty

      // this.topFirstPVariant.push({ weight: this.topFirstProduct });

      // console.log( this.topFirstPVariant)
      this.opt.variants = this.topFirstPVariant;
      this.opt.msg = this.message

      const cusid = localStorage.getItem('customerid');
      const integerValue = parseInt(cusid);
      this.ordermodule.customerid = integerValue
      this.ordermodule.cid = 12



      this.CartId = product["cartid"]
      // console.log(this.CartId)
      this.ordermodule.options.push(this.opt)
      // Create a cart item object
      const cartItem = {
        id: product.products[0].id,
        name: product.products[0].name,
        imgUrl: product.products[0].imgUrl,
        quantity: this.counter,
        message: this.message,
        price: this._displayedPrice,
        grandTotal: this.displayedPrice,
        optionsprice: this.options,
        categoryId: product.products[0]?.categoryId
        // catId: 
      };
      this.ordermodule.quantity = this.counter,
        // console.log(cartItem)

        this.cartItem = cartItem
      this.ordermodule.product = this.cartItem
      // console.log(this.ordermodule)
      this.localCart.push(this.ordermodule)
      localStorage.setItem('Cart', JSON.stringify(this.localCart))

      this.modalService.open(this.loginModel, { centered: true, size: 'lg' });
    }
  }

  async goToCart(product: EcomProd) {
    const status = await this.productService.addToCart(this.ordermodule);
    if (status)
      this.router.navigate(['/shop/cart']);
  }

  localCart: any = []

  updateButtonText() {
    this.buttonText = this.cartItemCount > 0 ? 'Go to Cart' : 'Add to Cart';
  }

  // Buy Now
  async buyNow(product: any) {
    if (localStorage.getItem('denglu') === '1') {
      product.quantity = this.counter || 1;
      // this.submitted = true
      // if (this.productsideForm.invalid) {
      //   return;

      // }
      // this.message = this.productsideForm.controls.message.value;
      // console.log(this.message);

      // Update weight and options in the ordermodule
      this.ordermodule.weight = this.topFirstProduct;
      this.opt.addons = this.selectedOptions;
      this.opt.variants = this.topFirstPVariant;
      this.opt.msg = this.message
      const cusid = localStorage.getItem('customerid');
      const integerValue = parseInt(cusid);
      this.ordermodule.customerid = integerValue
      this.ordermodule.cid = 12


      this.ordermodule.options.push(this.opt)
      // Create a cart item object
      const cartItem = {
        id: product.products[0].id,
        name: product.products[0].name,
        imgUrl: product.products[0].imgUrl,
        quantity: this.counter,
        message: this.message,
        price: this._displayedPrice,
        grandTotal: this.displayedPrice,
        optionsprice: this.options
        // catId: 
      };
      this.ordermodule.quantity = this.counter,
        // console.log(cartItem)

        this.cartItem = cartItem
      this.ordermodule.product = this.cartItem


      // this.ordermodule.product = product.products;

      // console.log(this.ordermodule);
      // const status = await this.productService.addToCart(this.ordermodule);

      this.productService.SaveCArt(this.ordermodule).subscribe(response => {
        // console.log(response)
        const count = response.cartcount
        localStorage.setItem("myApp_CartCount", JSON.stringify(count));
        this.myService.cartsource.next(count)
        this.router.navigate(['/shop/checkout']);
      });


      // if (status)
      //   this.router.navigate(['/shop/checkout']);


    }
    else {
      this.modalService.open(this.loginModel, { centered: true, size: 'lg' });
    }

  }

  // Add to Wishlist
  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  // Toggle Mobile Sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }


  rows = [
    { name: 'Vanilla' },
    { name: 'Black Current' }
  ];


  // public ecomproducts: EcomProd[] = []; 
  // public productName
  // GetProductDetails() {
  //   this.productService.EcomProducts.subscribe(x => {
  //     this.ecomproducts = x
  //     console.log('ProductDetails', this.ecomproducts)

  //     this.productName = this.ecomproducts['products'][0].description.replace(/\s+/g, '-')
  //     console.log('productName', this.productName);
  //   })
  // } 

  egglessOption: string = "0";
  toggleEgglessOption6() {
    this.egglessOption = this.egglessOption === "0" ? "1" : "0";
    // console.log("Eggless option toggled to:", this.egglessOption);
  }


  selectedProductPrice: number = 0;
  selectedOptionsPrice: number = 0;
  grandTotal: number = 0;

  // DEFAULT CHECK PRODUCT WEIGHT CLICK

  qtyText: string = '';
  freeQty: number = 0;
  price: number = 0;

  firstClick = true;
  firstvarClick = true;


  filteredVariants: any = []

  updateDisplayedPrice(productId: number, event: MouseEvent, product) {
    this.VarId = 0
    // console.log("Product ID:", productId);
    // console.log("Product Details:", product);
    this.topFirstProduct = product


    // Store previously selected shape before updating variants
    const previousShape = this.topFirstPVariant ? this.topFirstPVariant.qtyText : "Round Shape";

    // console.log(this.VarId)
    if (this.VarId === 0) {
      // Ensure either "Round Shape" or "Heart Shape" is selected first
      this.topFirstPVariant = this.ecomprodvariants.find(v =>
        v.qtyText.includes("Round Shape") || v.qtyText.includes("Heart Shape")
      ) || this.ecomprodvariants[0];
    } else {
      this.topFirstPVariant = this.ecomprodvariants.find(x => x.id === this.VarId);
    }





    // Filter variants based on selected weight
    // console.log(this.filteredVariants)
    this.ecomprodvariants = this.filteredVariants.filter(x => x.paProdId === productId);

    // console.log(this.ecomprodvariants)
    if (product.totalQty > 2) {
      this.ecomprodvariants = this.ecomprodvariants.filter(x => x.qtyText.includes("Box Shape"));
    } else {
      this.ecomprodvariants = this.ecomprodvariants.filter(x =>
        x.qtyText.includes("Round Shape") || x.qtyText.includes("Heart Shape")
      );
    }

    // Update Eggless option dynamically based on selected weight
    this.ecomprodoptions = this.ecomprodoptionsall.filter(x => x.paProdId === productId);

    // Preserve already selected eggless option only if available in the new weight category
    if (this.selectedOptions.length > 0) {
      this.selectedOptions = this.selectedOptions.filter(option =>
        this.ecomprodoptions.some(opt => opt.id === option.id)
      );
    }

    // Update button states
    this.clickedStates = this.ecomprodoptions.map(option =>
      this.selectedOptions.some(selected => selected.id === option.id)
    );

    // Sort to prioritize "Round Shape" selection
    this.ecomprodvariants.sort((a, b) => {
      if (a.qtyText === "Round Shape") return -1;
      if (b.qtyText === "Round Shape") return 1;
      if (a.qtyText === "Heart Shape") return -1;
      if (b.qtyText === "Heart Shape") return 1;
      return 0; // Keep other variants in their original order
    });


    // Update selected product and pricing
    this.preDEfQTy = productId;
    const selectedProduct = this.ecomprodpredefined.find(prod => prod.id === productId);

    if (selectedProduct) {
      this.selkgprice = selectedProduct.price;
      this.topFirstPVariant = this.ecomprodvariants.find(v => v.qtyText === previousShape) ||
        this.ecomprodvariants.find(v => v.qtyText.includes("Round Shape")) ||
        this.ecomprodvariants.find(v => v.qtyText.includes("Heart Shape")) ||
        this.ecomprodvariants[0]; // Fallback to the first variant if none match

      this.varPrice = this.topFirstPVariant ? this.topFirstPVariant.price : 0;


      // Ensure updated total price calculation
      this.updateTotalPrice();
    } else {
      // console.error("Product with ID", productId, "not found.");
    }

    this.ecomprodvariants = this.ecomprodvariants.sort((a, b) => {
      return a.qtyText.trim() === "Round Shape" ? -1 : 1;
    });
    // console.log(this.ecomprodvariants)
  }





  updateDisplayedvarPrice(id: string) {
    // console.log(id)
    this.VarId = 0;
    const selectedVariant = this.ecomprodvariants.find(product => product.id === id);

    if (selectedVariant) {
      this.topFirstPVariant = selectedVariant;
      this.varPrice = selectedVariant.price || 0;

      // Ensure selected options' price updates correctly
      this.updateTotalPrice();
    }
  }



  updateDisplayedPriceTest(productId: string) {
    const selectedProduct = this.ecomprodpredefined.find(product => product.id === productId);
    if (selectedProduct) {
      this.displayedPrice = selectedProduct.price;
      if (this.topFirstProduct && this.topFirstProduct.id === productId) {
        this.topFirstProduct = null;
      } else {
        this.topFirstProduct = selectedProduct;
        // console.log('topFirstProduct', this.topFirstProduct);


        this.selkgprice = this.topFirstProduct.price




        this.options = this._options;



        this.displayedPrice = (this.selkgprice + this.options) * this.counter

        this.increment()
        this.decrement()
      }
    } else {
      // console.error("Product with ID", productId, "not found.");
    }
  }


  // EGGLESS ADDED

  _options = 0;
  options = 0
  clickedStates: boolean[] = [];
  selectedOptions: any[] = []


  Topt: number = 0
  // toggleButton(index: number, price: number, opt: any, check: boolean) {
  //   this.Topt = 0; // Reset total options price

  //   if (opt.category === "eggless") {
  //     // Deselect any previously selected Eggless option
  //     this.selectedOptions = this.selectedOptions.filter(x => x.category !== "eggless");
  //   }

  //   if (!check) {
  //     this.selectedOptions.push(opt);
  //   } else {
  //     this.selectedOptions = this.selectedOptions.filter(x => x.id !== opt.id);
  //   }

  //   // Reset button states
  //   this.clickedStates = this.ecomprodoptions.map(option =>
  //     this.selectedOptions.some(selected => selected.id === option.id)
  //   );

  //   // Calculate total additional price
  //   this.Topt = this.selectedOptions.reduce((total, ele) => total + ele.price, 0);

  //   // Update pricing variables
  //   this._options = this.Topt;
  //   this.options = this.Topt;

  //   console.log(this._options)

  //   console.log(this.options)

  //   // Update displayed price
  //   this.displayedPrice = (this.options + this.selkgprice + this.varPrice) * this.counter;
  // }

  toggleButton(index: number, price: number, opt: any, check: boolean, productId: number) {
    const data = this.ecomprodoptionsall.find(x => x.paProdId == productId);
    this.ecomprodoptions = data ? [data] : [];

    if (!check) {
      // Remove previous eggless selection for different weight before adding new one
      this.selectedOptions = this.selectedOptions.filter(x => x.id !== opt.id);
      this.selectedOptions.push(opt);
    } else {
      this.selectedOptions = this.selectedOptions.filter(x => x.id !== opt.id);
    }

    this.clickedStates = this.ecomprodoptions.map(option =>
      this.selectedOptions.some(selected => selected.id === option.id)
    );

    this.updateTotalPrice();
  }



  updateTotalPrice() {
    const selectedPrices = this.selectedOptions.map(opt => opt.price);
    const totalSelectedPrice = selectedPrices.length ? selectedPrices.reduce((a, b) => a + b, 0) : 0;

    // Ensure correct total price calculation
    this.displayedPrice = (this.selkgprice + totalSelectedPrice + this.varPrice) * this.counter;
    // console.log("Updated Price:", this.displayedPrice);
  }



  toggleButtonvariant(index: number, price: number, variant: any) {
    // console.log(index, price, variant)
  }


  chatmsg() {
    // console.log(this.message);
  }

  logincheck() {
    this.modalService.dismissAll();
    this.router.navigate(['/pages/login'])
  }

  public ImageSrc: string

  // Recprod: any = [{
  //   id: 1,
  //   images: 'assets/images/Recimg/popper-ecom-test.jpg',
  //   name: 'Popper Spray',
  //   Qty: 0,
  //   pri: 50
  // },
  // {
  //   id: 2,
  //   images: 'assets/images/Recimg/ribbon spray-ecom-test.jpg',
  //   name: 'Ribbon Spray',
  //   Qty: 0,
  //   pri: 40
  // },
  // {
  //   id: 3,
  //   images: 'assets/images/Recimg/cap-Ecom-test.jpg',
  //   name: 'Cap',
  //   Qty: 0,
  //   pri: 25
  // },
  // {
  //   id: 4,
  //   images: 'assets/images/Recimg/Baloons-Ecom-test.jpg',
  //   name: 'baloons',
  //   Qty: 0,
  //   pri: 20

  // }]

  RecQty: number = 0

  selectedItems: any = []

  decrement1(item) {
    console.log(item)
    // this.singleItm = item.Qty
    // this.ProdId = item.productId
    // console.log(item)
    // this.selectedItems = item

    // this.selectedItems.push(item)
    // console.log(this.selectedItems)
    if (item.Qty > 0) item.Qty--;
    // this.onchangecal()
    // if (item.PreQty > 0) item.PreQty--;

    // this.addRecItem(item)
  }

  singleItm: number = 0
  ProdId: number = 0


  increment1(item) {
    console.log(item)
    // this.singleItm = item.Qty
    // this.ProdId = item.productId
    // console.log(item)
    // this.selectedItems = item
    // console.log(this.selectedItems)
    // this.selectedItems.push(item)
    // console.log(this.selectedItems)
    if (item.Qty < 10) {
      item.Qty++;
    }
    // if (item.PreQty < 10) {
    //   item.PreQty++;
    // }
    // this.addRecItem(item)
    // this.onchangecal()
  }
  RecTotal: number = 0
  RecQTy: number = 0;
  // onchangecal() {
  //   this.selectedItems = [...new Set(this.selectedItems.map(x => x.productId))]
  //     .map(productId => this.selectedItems.find(x => x.productId === productId));



  //   this.selectedItems = this.selectedItems.filter(x => x.Qty > 0)
  //   console.log(this.selectedItems)
  //   // console.log(this.RecTotal)

  // }

  RecOrdItem: any = []

  RecModule: any = []

  addRecItem(item) {
    // console.log("addRecItem", item)
    if (item.Qty > 0) {
      item.preQty = item.Qty
    } 
    console.log("addRecItem", item)
    this.RecModule = []
    // this.selectedItems = []
    // this.selectedItems = [...new Set(this.selectedItems.map(x => x.productId))]
    //   .map(productId => this.selectedItems.find(x => x.productId === productId));

    this.selectedItems.push(item)
    const cusid = localStorage.getItem('customerid');
    const integerValue = parseInt(cusid);

    // this.selectedItems.forEach(element => {
    //   if (element.Qty > 0) {
    const cartItem = {
      id: item.productId,
      name: item.name,
      imgUrl: item.imgUrl,
      quantity: item.Qty,
      message: '',
      price: item.price,
      grandTotal: item.price * item.Qty,
      optionsprice: 0,
      PreQty: item.preQty
    };

    const ordermodule = {
      product: cartItem,
      weight: {
        id: item.id
      },
      options: [
        {
          addons: [],
          msg: ''
        }
      ],
      customerid: integerValue,
      quantity: item.Qty
    };

    this.RecModule.push(ordermodule);
    // }
    // });
    console.log(this.RecModule)
    const data = this.RecModule
    // if (item.Qty > 0) {
    if (item.preQty > 0 || item.Qty > 0) {
      this.RecModule.forEach(ele => {
        this.productService.SaveCArt(ele).subscribe(response => {
          // console.log(response)

          // if (item.Qty == 0) {
          //   this.toastrService.warning('Cart', ' Added Zero QTY!')
          //   const count = response.cartcount
          //   localStorage.setItem("myApp_CartCount", JSON.stringify(count));
          //   this.myService.cartsource.next(count)


          //   return;
          // }

          if (response.status == 200) {
            this.toastrService.success('Cart', ' Cart Added Successfully')
            setTimeout(() => {
              // this.modalService.open(this.RecomendProd, { centered: true, size: 'lg' });
            }, 2000);
          } else {
            this.toastrService.error('Cart', 'Cart AddedUnSuccessfully !..')
          }

          const count = response.cartcount
          localStorage.setItem("myApp_CartCount", JSON.stringify(count));
          this.myService.cartsource.next(count)


        });
      });
    } else {
      this.toastrService.warning('Cart', ' Added Zero QTY!')


    }


    this.selectedItems = [...new Set(this.selectedItems.map(x => x.productId))]
      .map(productId => this.selectedItems.find(x => x.productId === productId));

    this.RecTotal = 0;
    this.RecQTy = 0
    this.selectedItems.forEach(element => {
      element.total = element.Qty * element.price;
      this.RecTotal += element.total;
      this.RecQTy += element.Qty
    });

    // console.log(this.selectedItems)
    // } else {

    //   this.selectedItems = [...new Set(this.selectedItems.map(x => x.productId))]
    //     .map(productId => this.selectedItems.find(x => x.productId === productId));

    //   this.RecTotal = 0;
    //   this.selectedItems.forEach(element => {
    //     element.total = element.Qty * element.price;
    //     this.RecTotal += element.total;
    //   });
    //   this.toastrService.error('Add-ons', ' Add-ons Cannot Selected')
    // }


    // this.RecModule.forEach(ele => {
    //   this.productService.SaveCArt(ele).subscribe(response => {
    //     // console.log(response)

    //     if (response.status == 200) {

    //       setTimeout(() => {
    //         // this.modalService.open(this.RecomendProd, { centered: true, size: 'lg' });
    //       }, 2000);
    //     } else {
    //       this.toastrService.error('Cart', 'Cart AddedUnSuccessfully !..')
    //     }

    //     const count = response.cartcount
    //     localStorage.setItem("myApp_CartCount", JSON.stringify(count));
    //     this.myService.cartsource.next(count)
    //     // console.log('11111111111111111111111111111111111111111111111111')
    //     this.productService.getcartdata()

    //   });
    // })




    // console.log(this.RecModule);
  }

  public ProductSliderConfig: any = ProductSlider;
  @Input() onHowerChangeImage: boolean = false; // Default False


  Contcart() {

    this.modalService.dismissAll();
    this.router.navigate(['/shop/cart']);
  }

  itemshare() {
    this.modalService.open(this.Share, { centered: true, size: 'sm' });

  }

  shareToWhatsapp() {
    const link = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(window.location.href);
    window.open(link, '_blank');
  }
  shareToInstagram() {

  }

  shareToFacebook() {

  }

  fdata: any = [];
  favbool = false;
  saveFav(item) {
    // console.log(item)
    // console.log(this.topFirstProduct)
    var data = {
      cid: 0,
      cname: this.prod[0]['categoryId'],
      img: this.prod[0]['imgUrl'],
      pid: this.prod[0]['id'],
      pname: this.prod[0]['name'],
      pri: this.topFirstProduct.price,
    }
    // console.log(item);
    // console.log(item['products'][0]['id']);

    if (localStorage.getItem("fav")) {
      var odata = JSON.parse(localStorage.getItem("fav"))
      // console.log("odata::", odata);

      const idpid = this.prod[0]['id'];
      // console.log("idpid")

      var isPresent = odata.some(function (el) { return el.pid === item['products'][0]['id'] });
      if (isPresent) {

        const objWithIdIndex = odata.findIndex((obj) => obj.pid === idpid);
        odata.splice(objWithIdIndex, 1);
        localStorage.setItem("fav", JSON.stringify(odata));
        this.toastrService.warning('Removed Favourite', this.prod[0]['name'])
        this.favbool = false;
      }
      else {
        odata.push(data)
        localStorage.setItem("fav", JSON.stringify(odata));
        this.toastrService.success('Saved Favourite', this.prod[0]['name'])
        this.favbool = true;
      }
    }
    else {
      localStorage.setItem("fav", JSON.stringify([data]));
      this.toastrService.success('Saved Favourite', this.prod[0]['name'])
      this.favbool = true;
    }
  }


  addallselected(data) {
    // console.log("Alldata:::", data)
    let i = 0;
    data.forEach(x => {

      if (x.Qty > 0) {
        i++;
        //console.log("gdfdf")
        this.addRecItem(x)
      }
    })

    if (i <= 0) {
      this.toastrService.warning("Qty count Zero, No one product Added! ")
    }
  }








  review = [{
    id: 1,
    name: "RobinHood",
    datetime: '19th july 2024',
    location: 'chennai',
    rating: 1,
    description: "It was a happy moment and Fb Cakes did make it special by delivering delicious cake to my best friend on their anniversary",
    // img1: "https://media.nw18.com/media-assets/n3opql/749f573e-38a5-4d94-81af-274f23d1bd2d/07-2024/18-2024/66993575c73202c1657a77dc/720p-h264.mp4",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1627731401.0494.jpeg?tr=w-542,h-460",
    img2: ''
  },
  {
    id: 2,
    name: "Gopi kumar",
    datetime: '5th mar 2024',
    location: 'Karapakkam',
    rating: 5,
    description: "The cake was absolutely delicious! My family loved it. Thanks Fb Cakes for the wonderful service. The delivery was also on time.",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1708597812_113400.jpeg?tr=w-400",
    img2: ''
  },
  {
    id: 3,
    name: "Vasekaran",
    datetime: '25th Dec 2023',
    location: 'Thaiyur',
    rating: 4,
    description: "The cake quality and the taste was awesome.",
    img1: '',
    img2: ''
  },
  {
    id: 4,
    name: "Durai Raj",
    datetime: '8th may 2024',
    location: 'Kelambakam',
    rating: 3,
    description: "IT WAS PERFECT!! ALWAYS THANKFUL FOR YOUR SERVICES!! ????✨,It’s amazing since it’s a gift I haven’t tasted the cake Slightly expensive but worth it for quick delivery??",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1720085787_605281.jpeg?tr=w-400",
    img2: ''
  }, {
    id: 5,
    name: "Rohith Khan",
    datetime: '27th Jan 2024',
    location: 'Thiruporur',
    rating: 4,
    description: "The people are very polite and hard working. The taste is also good.",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1717237081_425418.jpeg?tr=w-400",
    img2: "https://imgcdn.floweraura.com/fa/review_image/1716226515_956013.jpeg?tr=w-400"
  },
  {
    id: 1,
    name: "RobinHood",
    datetime: '19th july 2024',
    location: 'chennai',
    rating: 1,
    description: "It was a happy moment and Fb Cakes did make it special by delivering delicious cake to my best friend on their anniversary",
    // img1: "https://media.nw18.com/media-assets/n3opql/749f573e-38a5-4d94-81af-274f23d1bd2d/07-2024/18-2024/66993575c73202c1657a77dc/720p-h264.mp4",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1627731401.0494.jpeg?tr=w-542,h-460",
    img2: ''
  },
  {
    id: 2,
    name: "Gopi kumar",
    datetime: '5th mar 2024',
    location: 'Karapakkam',
    rating: 5,
    description: "The cake was absolutely delicious! My family loved it. Thanks Fb Cakes for the wonderful service. The delivery was also on time.",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1708597812_113400.jpeg?tr=w-400",
    img2: ''
  },
  {
    id: 3,
    name: "Vasekaran",
    datetime: '25th Dec 2023',
    location: 'Thaiyur',
    rating: 4,
    description: "The cake quality and the taste was awesome.",
    img1: '',
    img2: ''
  },
  {
    id: 4,
    name: "Durai Raj",
    datetime: '8th may 2024',
    location: 'Kelambakam',
    rating: 3,
    description: "IT WAS PERFECT!! ALWAYS THANKFUL FOR YOUR SERVICES!! ????✨,It’s amazing since it’s a gift I haven’t tasted the cake Slightly expensive but worth it for quick delivery??",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1720085787_605281.jpeg?tr=w-400",
    img2: ''
  }, {
    id: 5,
    name: "Rohith Khan",
    datetime: '27th Jan 2024',
    location: 'Thiruporur',
    rating: 4,
    description: "The people are very polite and hard working. The taste is also good.",
    img1: "https://imgcdn.floweraura.com/fa/review_image/1717237081_425418.jpeg?tr=w-400",
    img2: "https://imgcdn.floweraura.com/fa/review_image/1716226515_956013.jpeg?tr=w-400"
  }]

  reviewImage: any = []
  Images = []
  viewImg(item) {
    // console.log(item)
    this.reviewImage = []
    this.Images = []

    this.reviewImage.push(item)
    // console.log(this.reviewImage)
    this.reviewImage.forEach(element => {
      element.showImg = element.img[0]?.url
      this.Images = element.img
    });
    // console.log(this.reviewImage)
    this.modalService.open(this.ReviewImg, { centered: true, size: 'lg' });
  }

  viewImg2nd(item) {
    // console.log(item)
    this.reviewImage = []
    this.Images = []

    this.reviewImage.push(item)
    this.reviewImage.forEach(element => {
      element.showImg = element.img[1]?.url
      this.Images = element.img
    });
    // console.log(this.reviewImage)
    this.modalService.open(this.ReviewImg, { centered: true, size: 'lg' });
  }


  viewimg1(item) {
    // console.log(item)
    this.reviewImage = []
    this.reviewImage = item
    // this.reviewImage.push(item)
    // console.log(this.reviewImage)
    this.reviewImage.forEach(element => {
      // console.log(element,'--------------')
      element.showImg = element.img[0]?.url
    });
  }

  viewimg2(item) {
    // console.log(item)
    this.reviewImage = []
    this.reviewImage = item
    // this.reviewImage.push(item)
    this.reviewImage.forEach(element => {
      element.showImg = element.img[1]?.url
    });
  }

  getStarClass(index: number): string {
    // console.log(index)
    // console.log(this.finalratingstar)

    if (index < Math.floor(this.finalratingstar)) {
      return 'fa-star';
    } else if (index === Math.floor(this.finalratingstar) && this.finalratingstar % 1 !== 0) {
      return 'fa-star-half-o';
    } else {
      return 'fa-star-o';
    }
  }

  getStarColor(index: number): string {
    // console.log(index)
    return index < this.finalratingstar ? '#ffa200' : '#ccc';
  }

  loadReviews() {
    this.modalService.open(this.Reviews, { centered: true, size: 'lg' });
  }


  @ViewChild('reviewDiv') reviewDiv!: ElementRef;

  gotoreviewdiv(): void {
    if (this.reviewDiv) {
      this.reviewDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

}



